import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap'; // Bootstrap form components
import { FaBuilding, FaEye, FaEyeSlash } from 'react-icons/fa'; // Example icon

const ReusableInput = ({ label, value, onChange, placeholder, error, icon, name, required,type="text" }) => {
    const [showPassword, setShowPassword] = useState(false);
    
    const isPasswordField = type === "password";
    const inputType = isPasswordField ? (showPassword ? "text" : "password") : type;

    return (
        <Form.Group className="mb-4">
            <Form.Label className="input-label">
                {label} {required && <span className="text-danger">*</span>}
            </Form.Label>
            <div className="input-wrapper" style={{ position: 'relative' }}>
                <div className="input-icon">{icon}</div>
                <Form.Control
                    className="reusable-input"
                    type={inputType}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    name={name}
                    // isInvalid={!!error} // Highlight input if error exists
                    style={{
                        border: error ? "1px solid red" : "1px solid #ced4da",
                        paddingRight: isPasswordField ? "40px" : undefined
                    }}
                />
                {isPasswordField && (
                    <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        style={{
                            position: 'absolute',
                            right: '10px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            color: '#6c757d',
                            padding: '5px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </button>
                )}
            </div>
            {/* Only show error feedback if there is an error */}
            {
                error && (
                    <div
                        style={{
                            width: "100%",
                            margin: "0px",
                            padding: "0px",
                            display: "flex",
                            position: "relative",
                        }}
                    >
                        {error && 
                            <span 
                                style={{fontSize: ".8rem",color: "red", position: "absolute", bottom: "-17px", left: "0px"}}
                            >
                                {error}
                            </span>}
                    </div>
                )
            }
        </Form.Group>
    );
};

ReusableInput.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    error: PropTypes.string,
    icon: PropTypes.element,
    name: PropTypes.string.isRequired,
    required: PropTypes.bool
};

ReusableInput.defaultProps = {
    placeholder: '',
    error: '',
    icon: <FaBuilding />,
    required: false
};

export default ReusableInput;